/* wh1-blog.js : WILDHORN DARK blog index + article (POLICIES-BLOG builder, theme 188568469748).
   Port of the preview /site/blogs/news (+ /<handle>) built by /root/workspace/wildhorn-lp/site/blog-src/gen.py.
   Index  : "Load more" (24 shown, +12 per click); cards past the first paginate page are fetched from
            ?page=N&section_id=<id> (Shopify paginates 50 max).
   Article: the article body Shopify stores is restructured like gen.py parse()/build_article(): lead ->
            answer box, h2 ids + contents (side + phone), mid product card, pull quote (3 preview articles),
            inline "Shop Wild Bison" buttons removed, FAQ -> accordion section, FDA line -> under the FAQ,
            "Written by" -> author row, image credit -> cover caption. Reading bar + contents highlight = JS_ARTICLE. */
(function () {
  'use strict';
  var d = document, W = window;
  var PRODUCT = '/products/wildhorn-bison?view=shop';   /* 01/11 owner: product links of the article text -> the ?view=shop page */
  var CHEV = '<svg viewBox="0 0 16 16" fill="none" stroke="#fff" stroke-width="2.4" aria-hidden="true"><path d="M3 6l5 5 5-5"/></svg>';
  var BISON = '<svg viewBox="0 0 512 512" aria-hidden="true"><use href="#bisonx"/></svg>';
  /* gen.py LAYOUT: pull quote before h2 index N, mid product card before h2 index M */
  var LAYOUT = {
    'dietary-fat-testosterone-men-over-45': { pull: [5, 'Big dietary overhauls fail.', 'Small, consistent swaps stick.'], mid: 3 },
    'resistance-training-testosterone': { pull: [6, 'One hard workout doesn\'t produce lasting hormonal change.', 'A well-structured program sustained over time does.'], mid: 2 },
    'chronic-stress-testosterone-levels': { pull: [1, 'When cortisol goes up,', 'testosterone tends to go down.'], mid: 3 }
  };
  var DEFAULT_MID = 3;
  /* the preview was generated from the plain text of each article, so it shows no bold / italic inside the
     body (e.g. "Whole eggs." lead-ins, journal names). true = same look as the preview; false = keep the
     article's own bold / italic. */
  var FLATTEN = true;

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
  }
  function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60); }

  /* ================================================================ index */
  function index() {
    var grid = d.getElementById('bl-grid'), btn = d.getElementById('bl-more-btn'), count = d.getElementById('bl-count');
    if (!grid || !btn || !count) return;
    var STEP = 12;
    var total = parseInt(grid.getAttribute('data-total'), 10) || 0;
    var next = parseInt(grid.getAttribute('data-next-page'), 10) || 0;
    var src = grid.getAttribute('data-src') || '';
    var busy = false;
    function cards() { return [].slice.call(grid.querySelectorAll('.bl-card')); }
    function sync() {
      var n = cards().filter(function (c) { return !c.hidden; }).length;
      count.textContent = 'Showing ' + n + ' of ' + total + ' articles';
      btn.hidden = n >= total;
    }
    function fetchMore() {
      if (!next || !src) return Promise.resolve(false);
      var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'page=' + next + '&section_id=' + encodeURIComponent(grid.getAttribute('data-section'));
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var g = doc.getElementById('bl-grid');
        if (!g) { next = 0; return false; }
        [].slice.call(g.querySelectorAll('.bl-card')).forEach(function (c) { c.hidden = true; grid.appendChild(d.importNode(c, true)); });
        next = parseInt(g.getAttribute('data-next-page'), 10) || 0;
        return true;
      }).catch(function () { next = 0; return false; });
    }
    function reveal() {
      var hid = cards().filter(function (c) { return c.hidden; });
      if (hid.length < STEP && next && !busy) {
        busy = true; btn.setAttribute('aria-busy', 'true');
        return fetchMore().then(function () { busy = false; btn.removeAttribute('aria-busy'); reveal(); });
      }
      var show = hid.slice(0, STEP);
      show.forEach(function (c) { c.hidden = false; });
      if (show[0]) { try { show[0].focus({ preventScroll: true }); } catch (e) {} }
      sync();
    }
    btn.addEventListener('click', function () { if (!busy) reveal(); });
    sync();
  }

  /* ================================================================ article */
  function isShopButton(el) {
    if (el.tagName !== 'P') return false;
    var a = el.querySelector('a');
    if (!a || el.children.length !== 1 || el.textContent.trim() !== a.textContent.trim()) return false;
    return /^Shop Wild Bison\b/.test(a.textContent.trim());
  }

  function tidy(html) {
    /* gen.py inline(): '( [' -> '([', ') )' -> '))', no space before punctuation after a link */
    return html.replace(/\(\s+<a /g, '(<a ').replace(/<\/a>\s+\)/g, '</a>)').replace(/<\/a>\s+([,.:;])/g, '</a>$1').trim();
  }

  function flatten(root) {
    if (!FLATTEN) return;
    [].slice.call(root.querySelectorAll('strong,b,em,i')).forEach(function (n) {
      while (n.firstChild) n.parentNode.insertBefore(n.firstChild, n);
      n.parentNode.removeChild(n);
    });
  }

  function fixLinks(root) {
    [].slice.call(root.querySelectorAll('a[href]')).forEach(function (a) {
      var h = a.getAttribute('href') || '';
      if (/^\/products\//.test(h)) { a.setAttribute('href', PRODUCT); a.removeAttribute('target'); a.removeAttribute('rel'); }
      else if (/^https?:\/\//.test(h) && !/^https?:\/\/(www\.)?trywildhorn\.com/.test(h)) { a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener'); }
      a.removeAttribute('style');
    });
    flatten(root);
  }

  function article() {
    var body = d.querySelector('.ar-body[data-wh1-raw]');
    if (!body) return;
    try {
      /* Liquid article.handle is "<blog>/<article>" */
      var handle = (body.getAttribute('data-handle') || '').split('/').pop();
      var lay = LAYOUT[handle] || { pull: null, mid: DEFAULT_MID };
      var lead = null, credit = '', blocks = [], faq = [], disc = '', byline = '', inFaq = false, lastQ = null;
      [].slice.call(body.children).forEach(function (el) {
        var tag = el.tagName, txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!txt && !el.querySelector('img,iframe,video,table')) return;
        if (/^These statements have not been evaluated/.test(txt)) { disc = txt; return; }
        if (/^Written by /.test(txt)) { byline = txt; return; }
        if (/^["\u201c]/.test(txt) && txt.indexOf('licensed under CC') > -1) { credit = txt; return; }
        if (tag === 'H2') {
          if (txt.toLowerCase() === 'frequently asked questions') { inFaq = true; return; }
          if (!inFaq) { blocks.push(['h2', txt]); return; }
        }
        if (inFaq) {
          var st = el.firstElementChild;
          if (tag === 'P' && st && st.tagName === 'STRONG' && el.innerHTML.trim().indexOf('<strong') === 0) {
            var c = el.cloneNode(true), q = c.firstElementChild.textContent.trim();
            c.removeChild(c.firstElementChild);
            var html = c.innerHTML.replace(/^\s*<br\s*\/?>/, '').trim();
            faq.push([q, html]); lastQ = faq[faq.length - 1];
          } else if (/^H[34]$/.test(tag)) {
            faq.push([txt, '']); lastQ = faq[faq.length - 1];
          } else if (lastQ && tag === 'P') {
            lastQ[1] += (lastQ[1] ? ' ' : '') + el.innerHTML.trim();
          }
          return;
        }
        if (isShopButton(el)) { blocks.push(['shop']); return; }
        if (lead === null && !blocks.length && tag === 'P') { lead = el; return; }
        blocks.push(['el', el]);
      });

      /* h2 ids */
      var used = {}, ids = [], h2s = blocks.filter(function (b) { return b[0] === 'h2'; });
      h2s.forEach(function (b) {
        var s = slug(b[1]) || 'section';
        while (used[s]) s += '-2';
        used[s] = 1; ids.push(s);
      });
      var tocItems = h2s.map(function (b, i) { return '<li><a href="#' + ids[i] + '">' + esc(b[1]) + '</a></li>'; }).join('');
      var tpl = d.getElementById('ar-mid-tpl');
      var mid = tpl ? tpl.innerHTML.trim() : '';
      var out = [];
      if (lead) {
        fixLinks(lead);
        out.push('<div class="ar-answer"><p class="ar-lead">' + tidy(lead.innerHTML) + '</p></div>');
      }
      if (h2s.length) out.push('<details class="ar-toc-m"><summary>In this article' + CHEV.replace('stroke="#fff"', 'stroke="currentColor"') + '</summary><ol>' + tocItems + '</ol></details>');
      var hi = -1;
      blocks.forEach(function (b) {
        if (b[0] === 'h2') {
          hi++;
          if (lay.mid === hi && mid) out.push(mid);
          if (lay.pull && lay.pull[0] === hi) out.push('<blockquote class="ar-pull"><p>' + esc(lay.pull[1]) + ' <span>' + esc(lay.pull[2]) + '</span></p></blockquote>');
          out.push('<h2 id="' + ids[hi] + '">' + esc(b[1]) + '</h2>');
        } else if (b[0] === 'el') {
          var el = b[1];
          fixLinks(el);
          if (el.tagName === 'P') out.push('<p>' + tidy(el.innerHTML) + '</p>');
          else if (el.tagName === 'UL' || el.tagName === 'OL') {
            var t = el.tagName.toLowerCase();
            out.push('<' + t + '>' + [].slice.call(el.children).map(function (li) { return '<li>' + tidy(li.innerHTML) + '</li>'; }).join('') + '</' + t + '>');
          } else { el.removeAttribute('style'); out.push(el.outerHTML); }
        }
      });
      var by = byline || "Written by The Wildhorn Desk, Men's Health Editor.";
      out.push('<div class="ar-author"><span class="ar-av">' + BISON + '</span><p>' + esc(by).replace('The Wildhorn Desk', '<b>The Wildhorn Desk</b>') + '</p></div>');
      body.innerHTML = out.join('\n');
      body.removeAttribute('data-wh1-raw');

      /* side contents */
      var side = d.querySelector('.ar-toc');
      if (side) {
        if (h2s.length) side.querySelector('ol').innerHTML = tocItems;
        else side.parentNode.removeChild(side);
      }

      /* cover caption */
      var fig = d.querySelector('.ar-cover');
      if (fig && credit) {
        var m = /^["\u201c](.+?)["\u201d] by (.+?) is licensed under (CC BY(?:-[A-Z]+)* [\d.]+)\. To view a copy of this license, visit (\S+?)\.?$/.exec(credit);
        var cap = d.createElement('figcaption');
        cap.innerHTML = m ? '&ldquo;' + esc(m[1]) + '&rdquo; by ' + esc(m[2]) + ', licensed under <a href="' + esc(m[4]) + '" target="_blank" rel="noopener">' + esc(m[3]) + '</a>.' : esc(credit);
        fig.appendChild(cap);
      }

      /* FAQ + FDA line */
      var faqSec = d.getElementById('faq');
      if (faqSec) {
        var acc = faqSec.querySelector('.faq6');
        if (faq.length && acc) {
          acc.innerHTML = faq.map(function (f, i) {
            var a = d.createElement('div'); a.innerHTML = f[1]; fixLinks(a);
            return '<details' + (i === 0 ? ' open' : '') + '><summary>' + esc(f[0]) + CHEV + '</summary><div class="in"><p>' + tidy(a.innerHTML) + '</p></div></details>';
          }).join('');
        } else {
          [].slice.call(faqSec.querySelectorAll('#faq-h,.faq6')).forEach(function (n) { n.parentNode.removeChild(n); });
        }
        var fda = faqSec.querySelector('.ar-fda');
        if (fda) { if (disc) fda.textContent = disc; else fda.parentNode.removeChild(fda); }
        if (!faq.length && !disc) faqSec.parentNode.removeChild(faqSec);
      }
    } catch (e) {
      body.removeAttribute('data-wh1-raw');
      if (W.console) console.error('wh1-blog', e);
    }
    progress();
  }

  /* gen.py JS_ARTICLE: reading bar + contents highlight */
  function progress() {
    var body = d.querySelector('.ar-body'), bar = d.querySelector('.ar-progress span');
    if (!body || !bar) return;
    var ticking = false;
    function update() {
      ticking = false;
      var r = body.getBoundingClientRect(), vh = W.innerHeight;
      var p = (vh - r.top) / (r.height + vh * 0.2);
      bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, p)).toFixed(4) + ')';
    }
    W.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    W.addEventListener('resize', update);
    update();
    var links = [].slice.call(d.querySelectorAll('.ar-toc a[href^="#"]'));
    if (!links.length || !('IntersectionObserver' in W)) return;
    var byId = {};
    links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var heads = [].slice.call(body.querySelectorAll('h2[id]'));
    if (!heads.length) return;
    function mark(id) { links.forEach(function (a) { a.setAttribute('aria-current', String(a === byId[id])); }); }
    function cur() {
      var c = null;
      heads.forEach(function (h) { if (h.getBoundingClientRect().top < 160) c = h.id; });
      mark(c || heads[0].id);
    }
    var io = new IntersectionObserver(cur, { rootMargin: '-120px 0px -55% 0px', threshold: [0, 1] });
    heads.forEach(function (h) { io.observe(h); });
    W.addEventListener('scroll', cur, { passive: true });
  }

  function init() { index(); article(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
